__turbopack_context__.v({
  "className": "basefont_980af43c-module__FcR2GW__className",
  "variable": "basefont_980af43c-module__FcR2GW__variable",
});
